import { LuCheck, LuClock, LuMapPin, LuUsers } from "react-icons/lu"
import type { Event } from "@apps/gwservice/types"
import { formatEventTimeRange } from "~/lib/utils"

export function EventCard({ event, onClick }: { event: Event; onClick: () => void }) {
  const time = formatEventTimeRange(event.date, event.endTime)

  return (
    <div
      onClick={onClick}
      className={`relative overflow-clip bg-white rounded-md shadow-sm border-l-4 ${event.attend === "go" ? "border-l-primary" : "border-l-muted"} mb-s`}
    >
      <div className="p-s flex flex-col gap-xs">
        <div className="flex items-start gap-xs mb-xs">
          <div lang="ru" className="flex-1 font-semibold text-base hyphens-auto">
            {event.title}
          </div>
          <span
            className={`shrink-0 flex items-center gap-0.5 text-secondary mt-0.5 ${event.attend === "go" ? "visible" : "invisible"}`}
          >
            <LuCheck className="size-icon-s" /> Иду
          </span>
        </div>
        <div className="flex items-center gap-xs text-secondary">
          <LuUsers className="size-icon-s shrink-0" />
          <span className="truncate">{event.group?.name ?? "<УДАЛЕНО>"}</span>
        </div>
        <div className="flex items-center gap-xs text-muted-foreground">
          <LuClock className="size-icon-s shrink-0" />
          <span>{time}</span>
        </div>
        {event.location && (
          <div className="flex items-center gap-xs text-muted-foreground">
            <LuMapPin className="size-icon-s shrink-0" />
            <span className="truncate">{event.location}</span>
          </div>
        )}
      </div>
    </div>
  )
}
